import { countdown } from "./booking";
import { BOOKING_VESSELS, BOOKING_VESSEL_ETD } from "./fixtures";
import type { BookingRequest } from "./types";

// Góc nhìn Tàu của Mint-Booking (vsAll / vsF / vsSel trong board): mỗi chuyến tàu một dòng, panel phải = mốc cut-off + yêu cầu trên tàu.

export interface VesselRow {
  key: string;
  name: string;
  meta: string;
  rows: BookingRequest[];
  si: string | null;
  cy: string | null;
  /** đổi lịch (thư hãng khác lịch) */
  change: string | null;
  /** chip "Đổi lịch" ở danh sách: chỉ khi hãng đã báo đổi (WHL delay chỉ hiện ở panel) */
  listFlag: boolean;
}

/** Thứ tự chuyến của board (VORD, không có "Chưa chọn chuyến"). */
const ORDER = ["cma", "kmtc", "one", "ym", "msc", "wh"];
/** Chuyến chưa có yêu cầu (VEXTRA): chỉ hiện ở phạm vi "Tất cả". */
const EXTRA: ReadonlyArray<{ name: string; meta: string; cy: string }> = [
  {
    name: "YM INSTRUCTION 348S",
    meta: "YML · CAT LAI TMNL · ETD 30/Oct 10:00",
    cy: "29/Oct 12:00",
  },
  {
    name: "ONE ALTAIR 076E",
    meta: "ONE · GEMALINK · ETD 25/Oct 18:00",
    cy: "22/Oct 20:00",
  },
  {
    name: "WAN HAI 372 E031",
    meta: "WHL · GEMALINK · ETD 25/Oct 06:00",
    cy: "23/Oct 15:00",
  },
];
const WH_DELAY = "Thư WHL báo delay 30 giờ · ETD mới 03/Nov 04:00";

/** Dòng meta gọn của board (VINFO): hãng · terminal · ETD — bỏ phần Closing CY (đã có chip CY). */
function shortMeta(key: string, line: string): string {
  const parts = line.split(' · ').filter((p) => !p.startsWith('Closing') && !p.startsWith('ETD'));
  return [...parts, `ETD ${BOOKING_VESSEL_ETD[key] ?? '—'}`].join(' · ');
}

export function vesselRows(requests: readonly BookingRequest[]): VesselRow[] {
  const real = ORDER.filter((k) => BOOKING_VESSELS[k]).map((k) => {
    const rows = requests.filter((r) => r.vessel === k);
    const r0 = rows.find((r) => r.siCutoff) ?? rows[0];
    const v = BOOKING_VESSELS[k]!;
    return {
      key: k,
      name: v.name,
      meta: shortMeta(k, v.line),
      rows,
      si: r0?.siCutoff ?? null,
      cy: r0?.cyCutoff ?? null,
      listFlag: !!v.change,
      change: v.change
        ? `ETD ${v.change.from} → ${v.change.to} · ${v.change.why}`
        : k === "wh"
          ? WH_DELAY
          : null,
    };
  });
  return [
    ...real,
    ...EXTRA.map((e, i) => ({
      key: `x${i}`,
      name: e.name,
      meta: e.meta,
      rows: [],
      si: null,
      cy: e.cy,
      change: null,
      listFlag: false,
    })),
  ];
}

export function vesselFilter(
  list: readonly VesselRow[],
  mode: "bk" | "all",
  q: string,
): VesselRow[] {
  const nq = q.trim().toLowerCase();
  return list.filter(
    (v) =>
      (mode === "all" || v.rows.length > 0) &&
      (!nq || `${v.name} ${v.meta}`.toLowerCase().includes(nq)),
  );
}

export type MarkTone = "err" | "warn" | "lb";
export interface Mark {
  k: string;
  v: string;
  cd: string;
  tone: MarkTone;
}

/** Chip / mốc kèm đếm ngược theo giờ hãng (board `vsChip` / `cdOf`). */
export function mark(label: string, value: string | null): Mark {
  const cd = countdown(value, false);
  return {
    k: label,
    v: value ?? "—",
    cd: cd ? cd.k : "",
    tone: cd && cd.mins < 0 ? "err" : cd && cd.mins < 1440 ? "warn" : "lb",
  };
}

export function vesselMarks(v: VesselRow): Mark[] {
  const etd =
    BOOKING_VESSEL_ETD[v.key] ??
    v.meta.split("ETD ")[1]?.split(" · ")[0] ??
    null;
  return [
    mark("ETD", etd ?? null),
    mark("Closing CY", v.cy),
    mark("Doc cut-off", v.si),
    { k: "ICD closing", v: "—", cd: "", tone: "lb" },
  ];
}
